module.exports = __webpack_public_path__ + "img/payment_pc_05.32411e55.png";